import { Value } from '@philips-internal/oswald-ui-core';

import { ApprovalOrderItemResponse } from './approval-process-modal-business';

interface ValudatePurchaseUnitValueRequest {
  sequence: number | string,
  approvalCeiling: boolean,
  includeBalance: boolean
  orderType: string
}

type ValidatePurchaseUnitValueResponse = {
  validate: boolean,
  stepTwo: boolean,
  includeBalance: boolean,
  finish: boolean
};

interface FormData extends ValudatePurchaseUnitValueRequest, Record<string, Value> {}

const normalizeValidatePurchaseUnitValueBody = (approvalSequence: number | string, approvalOrderItemResponse: ApprovalOrderItemResponse, orderType: string): FormData => ({
  sequence: approvalSequence,
  approvalCeiling: approvalOrderItemResponse.approvalCeiling,
  includeBalance: approvalOrderItemResponse.includeBalance,
  orderType: orderType,
});
  
export {
  normalizeValidatePurchaseUnitValueBody,
  ValidatePurchaseUnitValueResponse,
};
